import * as React from 'react';

import { Typography, Grid, Box, Button } from '@mui/material';
import { useTranslation } from 'next-i18next';

import { Style, HeaderContainer, SearchNotFoundStyle } from './style';

import BreadCrumbs from 'src/components/atoms/breadcrumb';
import NextLink from 'src/components/atoms/link';
import { IBreadcrumb } from 'src/interfaces';

type Props = {
  contentHeight: string;
  breadcrumbList: IBreadcrumb[];
  headerTitle?: string;
  headerDesc?: string;
  backgroundImage?: string | boolean;
  isSupportLargeScreen?: boolean;
};

const Heading = ({
  contentHeight,
  breadcrumbList,
  headerTitle,
  headerDesc,
  backgroundImage,
  isSupportLargeScreen,
}: Props) => {
  const breadcrumbs = breadcrumbList.map((item, index, arr) => {
    if (!item.url) {
      return (
        <Typography key={`cate_id_${index}`} color="#00000099">
          {item.description}
        </Typography>
      );
    }
    return (
      <NextLink key={`cate_id_${index}`} href={item.url}>
        <Button className="breadcrumb-link" variant="text">
          {item.description}
        </Button>
      </NextLink>
    );
  });

  if (!headerTitle && !headerDesc) {
    return (
      <SearchNotFoundStyle>
        <HeaderContainer isSupportLargeScreen={isSupportLargeScreen}>
          <BreadCrumbs breadcrumbs={breadcrumbs} />
        </HeaderContainer>
      </SearchNotFoundStyle>
    );
  }

  return (
    <Style backgroundImage={backgroundImage} contentHeight={contentHeight}>
      <HeaderContainer isSupportLargeScreen={isSupportLargeScreen} backgroundImage={backgroundImage}>
        <BreadCrumbs breadcrumbs={breadcrumbs} />
        <Grid item display="flex" alignItems="center" sx={{ height: '100%' }}>
          <Box sx={{ mb: 2 }}>
            {headerTitle && (
              <Typography className="title" variant="h1" sx={{ mt: '1rem' }}>
                {headerTitle}
              </Typography>
            )}
            {headerDesc && (
              <Typography className="description" variant="subtitle1">
                {headerDesc}
              </Typography>
            )}
          </Box>
        </Grid>
      </HeaderContainer>
    </Style>
  );
};

export default Heading;
